import { Action } from 'redux';
import { DataAction } from '../@types';

export const ServiceUnavailableActionType = 'serviceUnavailableError';

export type ServiceUnavailableAction = DataAction<typeof ServiceUnavailableActionType, Action>;

export function serviceUnavailableError(origin: Action): ServiceUnavailableAction {
	return {
		data: origin,
		type: ServiceUnavailableActionType
	};
}
